import { useEffect, useState } from "react";
import { Form, Input } from "antd";

import {
  DeleteOutlined,
  DownOutlined,
  FileOutlined,
  UpOutlined,
} from "@ant-design/icons";
import AccordionIcon from "../../assets/agendas-accordion-icon.png";

const KindRoom = (props: any) => {
  const [show, setShow] = useState<boolean>(false);
  const [title, setTitle] = useState<string | null>(null);

  const handleShowAccordion = () => {
    return setShow(!show);
  };

  useEffect(() => {
    const oneRoomKind =
      props.form.getFieldValue("roomKind")[props.restField.fieldKey];
    if (oneRoomKind !== undefined) setTitle(oneRoomKind.name);
  }, []);

  const changeText = (value: string) => {
    const oneRoomKind =
      props.form.getFieldValue("roomKind")[props.restField.fieldKey];

    setTitle(oneRoomKind?.name);
  };

  return (
    <div className="event-agendas">
      <div className="accordion">
        <div
          onClick={() => {
            handleShowAccordion();
          }}
          className={"accordion-item"}
        >
          <div className="header-box">
            <i
              className="bi bi-houses custom-h-i"
              style={{ color: "rgb(229 229 229)", fontSize: "20px" }}
            ></i>
            <p className="accordion-header" style={{ marginLeft: "10px" }}>
              {title == null || title == ""
                ? "Novi tip sobe"
                : `Tip sobe: ${title}`}
            </p>
          </div>
          <div style={{ marginRight: "10px" }} className="button-open">
            {show ? (
              <UpOutlined className="icon" />
            ) : (
              <DownOutlined className="icon" />
            )}
          </div>
        </div>
      </div>
      <div className={show ? "inner-container" : "close"}>
        <Form.Item
          {...props.restField}
          name={[props.name, "name"]}
          label="Naziv tipa sobe:"
          rules={[
            {
              required: true,
              message: "Potrebno je uneti naziv tipa sobe!",
            },
          ]}
        >
          <Input
            type="text"
            className="input-label"
            placeholder="Unesite naziv tipa sobe"
            onChange={(e) => {
              changeText(e.target.value);
            }}
          />
        </Form.Item>

        <Form.Item
          {...props.restField}
          name={[props.name, "totalNumber"]}
          label="Ukupan broj tipa sobe:"
          rules={[
            {
              required: true,
              message: "Potrebno je uneti ukupan broj tipa sobe!",
            },
          ]}
        >
          <Input
            type="number"
            className="input-label"
            placeholder="Unesite ukupan broj tipa sobe"
          />
        </Form.Item>

        <div className="footer-agenda">
          <span className="btn">
            <DeleteOutlined
              onClick={() => {
                props.remove(props.name);
              }}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default KindRoom;
